import React, { useState } from 'react';
import { Formik, Field, Form } from 'formik';
import { Button, Card, CardBody, FormGroup, Row, Col } from 'reactstrap';
import { toast } from 'react-toastify';
import { useParams } from 'react-router';
import InputMask from 'react-input-mask';
import { Input, Label } from 'reactstrap';
import FormikInputField from 'components/common/Fields/FormikInputField';
import FormikCheckboxField from 'components/common/Fields/FormikCheckboxField';
import useAxios from 'hooks/useAxios';
import { dateFormate } from 'utils/columns';
import save from "assets/icon/save.svg";

const Fax = (props) => {
  const API = useAxios();
  const {
    claimID,
    patientFirstName,
    patientLastName,
    patientDOB,
    providerID,
    providerFirstName,
    providerLastName,
    providerSpecialty,
    providerStatus,
    rxNumber,
    faxNumber,
    refillNumber,
    dateRXWritten,
    dateofService,
  } = props.claim;
  const { onClose, refresh , tenantID, coveredEntityID} = props;

  const [faxInputNumber, setFaxInputNumber] = useState(faxNumber);
  const [faxError, setFaxError] = useState('');
  // const { tenantID, coveredEntityID } = useParams();

  const initialValues = {
    updateFaxNumber: false,
    comments: '',
  };

  const handleSubmit = async (values, { setSubmitting, setErrors }) => {
    const convertFaxNumber = faxInputNumber.replace(/\D/g, '');
    if (convertFaxNumber.length < 10) return setFaxError(true);
    const payload = { claimID, ...values, faxNumber: convertFaxNumber };
    try {
      await API.post(`/${tenantID}/fax/send/${coveredEntityID}`, payload);
      toast.success('Updated Successfully!');
      refresh();
      setSubmitting(false);
      onClose();
    } catch (error) {
      setSubmitting(false);
      toast.error('An error occurred');
    }
  };

  return (
    <Card className='border-0 rounded shadow-top'>
      <CardBody>
        <Formik
          enableReinitialize={true}
          initialValues={initialValues}
          onSubmit={handleSubmit}
          // validationSchema={validationSchema}
          children={({ values, isSubmitting, isValid }) => {
            return (
              <Form>
                <Row className='align-items-center mb-3'>
                  <Col sm='4'>
                    <p className='f-14 mb-0'>
                      Patient First Name:
                      <b className='d-block  font-weight-500'>
                        {patientFirstName}
                      </b>
                    </p>
                  </Col>
                  <Col sm='4'>
                    <p className='f-14 mb-0'>
                      Patient Last Name:
                      <b className='d-block  font-weight-500'>
                        {patientLastName}
                      </b>
                    </p>
                  </Col>
                  <Col sm='4'>
                    <p className='f-14 mb-0'>
                      Patient DOB:
                      <b className='d-block  font-weight-500'>
                        {dateFormate(patientDOB)}
                      </b>
                    </p>
                  </Col>
                </Row>
                <Row className='mb-3'>
                  <Col sm='4'>
                    <p className='f-14 mb-0'>
                      Provider NPI:
                      <b className='d-block  font-weight-500'>
                        {providerID}
                      </b>
                    </p>
                  </Col>
                  <Col sm='4'>
                    <p className='f-14 mb-0'>
                      Provider First Name:
                      <b className='d-block  font-weight-500'>
                        {providerFirstName}
                      </b>
                    </p>
                  </Col>
                  <Col sm='4'>
                    <p className='f-14 mb-0'>
                      Provider Last Name:
                      <b className='d-block  font-weight-500'>
                        {providerLastName}
                      </b>
                    </p>
                  </Col>

                </Row>
                <Row className='mb-3'>
                  <Col sm='4'>
                    <p className='f-14 mb-0'>
                      Provider Specialty:
                      <b className='d-block  font-weight-500'>
                        {providerSpecialty}
                      </b>
                    </p>
                  </Col>
                  <Col sm='4'>
                    <p className='f-14 mb-0'>
                      Provider Status:
                      <b className='d-block  font-weight-500'>
                        {providerStatus}
                      </b>
                    </p>
                  </Col>
                </Row>
                <Row className='mb-3'>
                  <Col sm='4'>
                    <p className='f-14 mb-0'>
                      RX Number:
                      <b className='d-block font-weight-500'>
                        {rxNumber}
                      </b>
                    </p>
                  </Col>
                  <Col sm='4'>
                    <p className='f-14 mb-0'>
                      Refill Number:
                      <b className='d-block font-weight-500'>
                        {refillNumber}
                      </b>
                    </p>
                  </Col>
                  <Col sm='4'>
                    <p className='f-14 mb-0'>
                      Date Rx Written:
                      <b className='d-block font-weight-500'>
                        {dateFormate(dateRXWritten)}
                      </b>
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <p className='f-14 mb-0'>
                      Date of Service:
                      <b className='d-block  font-weight-500'>
                        {dateFormate(dateofService)}
                      </b>
                    </p>
                  </Col>
                </Row>
                <hr />
                <Row>
                  <Col sm='4'>
                    <FormGroup>
                      <Label className='label-color'>Fax Number</Label>
                      <InputMask
                        name='faxNumber'
                        mask='(999)999-9999'
                        value={faxInputNumber}
                        onChange={(e) => {
                          const value = e.target.value || '';
                          console.log(value);
                          setFaxError(false);
                          setFaxInputNumber(value);
                        }}
                      >
                        {(inputProps) => <Input {...inputProps} />}
                      </InputMask>
                      {faxError && (
                        <div className='text-danger font-size-12'>
                          Enter valid number
                        </div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col sm='12'>
                    <FormGroup>
                      <Field
                        key='updateFaxNumber'
                        id='updateFaxNumber'
                        name='updateFaxNumber'
                        type='checkbox'
                        component={FormikCheckboxField}
                        label='Update Fax Number'
                      />
                    </FormGroup>
                  </Col>
                  <Col sm='12'>
                    <FormGroup>
                      <Field
                        key='comments'
                        id='comments'
                        name='comments'
                        type='textarea'
                        label='Comment'
                        component={FormikInputField}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <div className='d-flex justify-content-end align-items-center'>
                  <div>
                    <Button
                      color='primary'
                      type='submit'
                      className='search'
                      size='sm'
                      disabled={!isValid || isSubmitting}
                    >
                      <span className="right_5">
                        <img src={save} alt="" />
                      </span>{" "} Send
                    </Button>
                  </div>
                </div>
              </Form>
            );
          }}
        ></Formik>
      </CardBody>
    </Card>
  );
};

export default Fax;
